/* Native informational-link behavior. Operational/app flows retain their own navigation. */
(function () {
  if (window.EZOKOExternalLinksLoaded) return;
  window.EZOKOExternalLinksLoaded = true;

  // Verified against Shopify domains and Markets on 2026-10-24. Exact host matching only.
  const firstParty = new Set([
    window.location.hostname, 'ezokofishing.com', 'www.ezokofishing.com',
    'ezokofishing.myshopify.com', 'account.ezokofishing.com'
  ]);
  const managed = new WeakMap();
  const excluded = '[data-ezoko-external-links="ignore"], .shopify-app-block, [id^="shopify-block-"], form, [contenteditable]:not([contenteditable="false"])';
  const operationalHosts = ['shop.app', 'checkout.shopify.com', 'accounts.shopify.com', 'admin.shopify.com', 'paypal.com', 'stripe.com', 'klarna.com', 'afterpay.com', 'affirm.com', 'getredo.com', 'redo.com', 'gorgias.com', 'gorgias.help', 'parcelpanel.com'];
  const operationalPath = /\/(?:checkouts?|cart|carts|accounts?|authentication|auth|oauth|authorize|callback|payments?|wallet|apps|returns-portal)(?:\/|$)/i;
  const operationalQuery = /^(?:return_to|return_url|redirect_uri|redirect_url|callback|client_id|access_token|checkout_url)$/i;

  function eligible(anchor) {
    const href = (anchor.getAttribute('href') || '').trim();
    if (!href || href[0] === '#' || anchor.hasAttribute('download') || anchor.hasAttribute('onclick') ||
        anchor.closest(excluded) || !anchor.closest('.shopify-section, #main')) return false;
    let url;
    try { url = new URL(href, document.baseURI); } catch (_) { return false; }
    if (!['http:', 'https:'].includes(url.protocol) || firstParty.has(url.hostname) || url.username || url.password) return false;
    if (operationalHosts.some(host => url.hostname === host || url.hostname.endsWith('.' + host)) || operationalPath.test(url.pathname)) return false;
    return !Array.from(url.searchParams.keys()).some(key => operationalQuery.test(key));
  }

  function update(anchor) {
    const owned = managed.get(anchor);
    const target = anchor.getAttribute('target');
    const applies = eligible(anchor);
    if (owned && (!applies || target !== '_blank')) {
      // Undo only our attributes when a dynamic link becomes internal or opts out.
      managed.delete(anchor);
      if (target === '_blank') anchor.removeAttribute('target');
      if (owned.addedNoopener) {
        const rel = (anchor.getAttribute('rel') || '').split(/\s+/).filter(token => token && token.toLowerCase() !== 'noopener').join(' ');
        if (rel) anchor.setAttribute('rel', rel);
        else anchor.removeAttribute('rel');
      }
    }
    if (!applies || (anchor.hasAttribute('target') && anchor.getAttribute('target').toLowerCase() !== '_blank')) return;
    const hasNoopener = (anchor.getAttribute('rel') || '').split(/\s+/).some(token => token.toLowerCase() === 'noopener');
    if (!anchor.hasAttribute('target')) {
      managed.set(anchor, { addedNoopener: !hasNoopener });
      anchor.setAttribute('target', '_blank');
    }
    if (!hasNoopener) anchor.setAttribute('rel', ((anchor.getAttribute('rel') || '') + ' noopener').trim());
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('a[href]')) update(root);
    root.querySelectorAll('a[href]').forEach(update);
  }

  scan(document);
  // One initial scan; thereafter inspect only added subtrees and relevant attribute changes.
  new MutationObserver(records => {
    const roots = new Set();
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(node => roots.add(node));
      else if (record.target.matches('a')) update(record.target);
      else if (record.attributeName === 'data-ezoko-external-links') roots.add(record.target);
    });
    roots.forEach(scan);
  }).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['href', 'target', 'rel', 'download', 'onclick', 'data-ezoko-external-links']
  });
})();
